import { forwardDocumentReducer } from './forwardDocument';
import { forwardRecipientsReducer } from './forwardRecipients';

const filesRootReducer = {
  forwardRecipients: forwardRecipientsReducer,
  forwardDocument: forwardDocumentReducer,
};

export { filesRootReducer };
